// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tvtime-importer-page[data-v-8febfa3a]{display:flex;justify-content:center;padding:60px 16px}", ""]);
// Exports
module.exports = exports;
